import { render, staticRenderFns } from "./profile-payment.vue?vue&type=template&id=382d83ee&"
import script from "./profile-payment.vue?vue&type=script&lang=js&"
export * from "./profile-payment.vue?vue&type=script&lang=js&"
import style0 from "./profile-payment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports